import type { FC, PropsWithChildren } from 'react';
import React, { useMemo } from 'react';

import type { LinkRenderingOptions } from './LinkRenderingContext';
import { LinkRenderingContext, defaultOptions } from './LinkRenderingContext';

export interface LinkRenderingOptionsProviderProps {
  readonly options: Partial<LinkRenderingOptions>;
}

const LinkRenderingOptionsProvider: FC<PropsWithChildren<LinkRenderingOptionsProviderProps>> = ({
  options,
  children,
}) => {
  const value = useMemo(() => ({ ...defaultOptions, ...options }), [options]);

  return <LinkRenderingContext.Provider value={value}>{children}</LinkRenderingContext.Provider>;
};

export default LinkRenderingOptionsProvider;
